var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModifyTableStyle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ModifyTableStyle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Blue{fill:#1177D7;}\r\n\t.Black{fill:#727272;}\r\n\t.st0{opacity:0.5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Black",
    d: "M28,10h-8V4h8V10z M26.3,14.9c0.5-0.5,1.1-0.7,1.7-0.8v-2h-8v6h3.2L26.3,14.9z M0,26h8v-6H0V26z M18,23.2V20 h-8v6h5.2L18,23.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Blue",
    d: "M0,4h8v6H0V4z M0,18h8v-6H0V18z M10,10h8V4h-8V10z M10,18h8v-6h-8V18z M29,23l-8,8l-4-4l8-8L29,23z M30,22 l1.7-1.7c0.4-0.4,0.4-1,0-1.3l-2.7-2.7c-0.4-0.4-1-0.4-1.3,0L26,18L30,22z M16,28v4h4L16,28z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyTableStyle);
export default __webpack_public_path__ + "static/media/modify_table_style.d5b3bce0cda0d6cc510ad32307792ab5.svg";
export { ForwardRef as ReactComponent };